var React = require('react');
var styles = require('./Page3.scss');
import Divider from './Divider';

var Page3 = React.createClass({
    propTypes: {

    },
    getInitialState: function() {
        return {
            visible: this.props.visible,
            origin: this.props.origin
        };
    },
    getDefaultProps: function() {
        return {
            visible: true,
            origin: 'sv'
        };
    },
    componentWillReceiveProps: function(nextProps) {
        this.setState({
            visible: nextProps.visible,
            origin: nextProps.origin
        });
    },
    render: function() {
        if (!this.state.visible) {
            return null;
        }

        var scandic = (
            <div className={[styles.unit, styles.package].join(' ')}>
                <h2>Vinn en Mikasa VLS300, en bollpump och ett snygg BeachTravels-linne!</h2>
                <p>Hur?</p>
                <ol>
                    <li>Ta en skön bild på dej själv där du ser härligt glad ut.</li>
                    <li>Ladda upp den på din Facebook och/eller Instagram.</li>
                    <li>Skriv något i stil med: Yiiihhhhaaaaaaaaaaaaa!!! Jag har precis bokat vårens
                        bästa träningsresa med BeachTravels till Portugal. Ska du hänga med och bli grymmast i beachvolley?</li>
                    <li>Se till att du har gillat www.facebook.com/beachtravels och att
                        du taggar @beachtravels</li>
                </ol>
                <h3>Vem vinner matchbollen, pumpen och linnet?</h3>
                <p>Tävlingen håller på tom 2017-11-05. Vinnaren kommer finnas bland de 10 bidrag som
                    fått flest likes, delningar och kommentarer.</p>
            </div>
        );

        var other = (
            <div className={[styles.unit, styles.package].join(' ')}>
                <h2>Win a Mikasa VLS300, a ball pump and a supercool BeachTravels Tank top!</h2>
                <p>How?</p>
                <ol>
                    <li>Take a very happy photo of yourself</li>
                    <li>Upload it on your facebook wall and/or Instagram</li>
                    <li>Write something that contains following paragraphs (but you are more than welcome
                        to write more, of course):
                        <ol>
                            <li>BeachTravels</li>
                            <li>Beach volleyball trip</li>
                            <li>Portugal or Praia da Rocha</li>
                            <li>Wooohhhooooo, yiihhaaaaa, yeeeessssss, jippi or another weird and cheerful sound.</li>
                            <li>I've booked!</li>
                        </ol>
                    </li>
                    <li>Like our page on www.facebook.com/beachtravels and tag the picture with
                        #beachtravels
                    </li>
                </ol>
                <h3>Who will win the the ball, ball pump and the tank top?</h3>
                <p>The contest ends 2017-11-05. The ten entries with most likes, comments or shares, when the contest is over are in the main draw to win the Mikasa VLS300 and the tank top.
                </p>
            </div>
        );

        var competition = this.state.origin == 'sf' || this.state.origin == 'other' ? other : scandic;

        return (
            <div className={[styles.wrapper, 'wrapper-640'].join(' ')}>
                <div className={[styles.form, 'j-forms'].join(' ')}>
                    <div className={styles.content}>

                        <Divider value={0} label="Thank you for your reservation!" />

                        <div className={styles.intro}>
                            <p>A confirmation with payment details will shortly land in your inbox to the email you
                                specified. Please check your spam box if you haven't received the email.
                            </p>
                        </div>
                        {competition}
                    </div>
                </div>
            </div>

        )
    },
});

module.exports = Page3;


// WEBPACK FOOTER //
// ./app/components/Page3.js